import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getPermissionsService = (
  request?: t.GetPermissionsRequestType
) => {
  const GET_PERMISSIONS_API_ENDPOINT = `${apiCoreEndpoint}/auth/permission`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_PERMISSIONS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_PERMISSIONS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getRolePermissionsService = (
  request?: t.GetRolePermissionsRequestType
) => {
  const GET_PERMISSIONS_API_ENDPOINT = `${apiCoreEndpoint}/auth/permission/role`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_PERMISSIONS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_PERMISSIONS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getRolesService = (request?: t.GetRolesRequestType) => {
  const GET_ROLES_API_ENDPOINT = `${apiCoreEndpoint}/auth/role`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ROLES_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ROLES_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
